<template>
    <div>
      <div class="news-Centeru-banner" v-bind:style="{backgroundImage:'url(' + bg + ')',backgroundPosition:'center',backgroundRepeat:'no-repeat',backgroundSize: 'cover'}">
        <head-menu   fd="0"  current="3"></head-menu>
        <img :src="bg" class="news-Centeru-banner-img" style="display:block;width: 100%;position: relative;z-index: -100">
      </div>
      <div style="max-width: 1752px;margin: 0 auto;height: 54px;position: relative;top:-27px;box-shadow:1px 1px 5px 0px rgba(0, 0, 0, 0.2);background-color: #fff">
        <el-menu style="max-width: 1210px;margin:0 auto" :default-active="activeIndex"  mode="horizontal" @select="handleSelect">
          <!--<el-menu-item class="itemx-our-1" style="float: right" index="其他新闻" :class="{xz1:activeIndex==='其他新闻'}" @click="dataList(3)">其他新闻</el-menu-item>-->
          <el-menu-item v-if="language=='CN'" class="itemx-our-1 xi news-Centeru-tow-list1" index="道远资本观察" :class="{xz1:activeIndex==='道远资本观察'}" @click="dataList(1)">道远资本观察</el-menu-item>
          <el-menu-item v-if="language=='CN'" class="itemx-our-1 news-Centeru-tow-list1" index="道远资本快讯" :class="{xz1:activeIndex==='道远资本快讯'}" @click="dataList(2)">道远资本快讯</el-menu-item>
           <el-menu-item v-if="language=='EN'" class="itemx-our-1 xi news-Centeru-tow-list1" index="道远资本观察" :class="{xz1:activeIndex==='道远资本观察'}" @click="dataList(1)">Tao capital observation</el-menu-item>
          <el-menu-item v-if="language=='EN'" class="itemx-our-1 news-Centeru-tow-list1" index="道远资本快讯" :class="{xz1:activeIndex==='道远资本快讯'}" @click="dataList(2)">Tao capital insight</el-menu-item>
          <el-submenu class="news-Centeru-tow-list" style="float: right">
            <template v-if="language=='CN'" slot="title">分类</template>
            <template v-if="language=='EN'" slot="title">assort</template>
            <el-menu-item v-if="language=='CN'" index="道远资本观察" @click="dataList(1)" >道远资本观察</el-menu-item>
            <el-menu-item v-if="language=='CN'" index="道远资本快讯" @click="dataList(2)">道远资本快讯</el-menu-item>
            <el-menu-item v-if="language=='EN'" index="道远资本观察" @click="dataList(1)" >Tao capital observation</el-menu-item>
            <el-menu-item v-if="language=='EN'" index="道远资本快讯" @click="dataList(2)">Tao capital insight</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>

      <!--<el-row class="show-news-head-tlie2" style="margin-top: 0px">-->
        <!--<el-col :lg="{span:10,offset:0}":md="{span:11,offset:0}" :xs="24" style="margin-top: 30px;margin-bottom: 10px">-->
          <!--<div style="width: 99%;height: 1px;background-color:rgb(229, 229, 229);margin-top: 26px;" ></div>-->
        <!--</el-col>-->
        <!--<el-col :lg="{span:12,offset:0}":md="{span:13,offset:0}" :xs="24" style="margin-top: 30px;margin-bottom: 10px" >-->
          <!--<h3 style="font-weight: bold;border-bottom:1px solid #e5e5e5;padding-bottom: 10px;font-size: 40px;width: 99%;margin-left: 1%">-->
            <!--<span style="border-bottom: 2px solid #083A6F;padding-bottom: 10px">{{ENtitle}}</span>-->
          <!--</h3>-->
          <!--<div  style="font-size:30px;color:rgba(8,58,111,1);margin-top: 10px;text-align: left;width: 99%;margin-left:6%" :style="{'marginLeft':this.ENtitle=='Realated News'?'6%':'4%'}">&nbsp;&nbsp;&nbsp;&nbsp;{{CNtitle}}</div>-->
        <!--</el-col>-->
      <!--</el-row>-->
      <!--<div style="text-align:center;font-weight: bold;padding-bottom: 10px;font-size: 2em" class="show-news-head-tlie"> </div>-->
      <!--<div class="show-news-head-tlie"  style="text-align:center;font-weight: bold;padding-bottom: 10px;font-size: 2em;border-bottom:1px solid #e5e5e5">{{ENtitle}}</div>-->
      <!--<div class="show-news-head-tlie"  style="font-size:22px;color:rgba(8,58,111,1);margin-top: 10px;text-align: center;">{{CNtitle}}</div>-->


       <div>
         <div class="news-Centeru-tile">{{CNtitle}}</div>
         <div style="width:35px;height:4px;background:rgba(8,58,111,1);margin: 0 auto;margin-top: 20px"></div>
         <div  style="margin-top: 40px">
<!--         <div  style="margin-top: 100px">-->
           <div v-for="(item,index) in newList" @mouseover="over(index)" @click="linkinfo(item)" class="news-Centeru-nr" style="margin-top: 20px" :class="{'gd':!item.isShow}">
             <el-row  style="top:18px;">
               <el-col :lg="{span:8,offset:1}" :sm="{span:5,offset:1}" :md="{span:5,offset:1}" :xs="{span:22,offset:1}" v-show="item.isShow" stlye="text-align: justify">
                 <img style="width:100%;display: block" class="news-Centeru-imgx" :src="item.imgUrl" >
               </el-col>
               <el-col :lg="{span:11,offset:1}" :sm="{span:15,offset:2}" :md="{span:15,offset:2}" :xs="{span:22,offset:1}" stlye="text-align: justify" v-show="item.isShow">
                 <div style="height:21px;margin-top: 49px">
                   <div class="news-Centeru-text-one">{{CNtitle}}&nbsp|&nbsp{{item.title}}</div>
                 </div>
                 <div class="news-Centeru-text-tow">{{item.date}}</div>
                 <div class="news-Centeru-text-three">
                      {{item.title}}
                 </div>
               </el-col>
               <el-col  v-show="!item.isShow" :lg="{span:23,offset:1}"  :xs="{span:22,offset:1}" stlye="text-align: justify">
                 <div style="height:21px;">
                   <div class="news-Centeru-text-one">{{CNtitle}}&nbsp|&nbsp{{item.title}}</div>
                 </div>
                 <div class="news-Centeru-text-tow">{{item.date}}</div>
                 <div class="news-Centeru-text-three">
                   {{item.title}}
                 </div>
               </el-col>
             </el-row>
             <div>
             </div>
           </div>
         </div>
         <div v-show="isPageShow" style="margin: 0 auto;max-width:1210px;margin-top:30px">
           <el-pagination
             @current-change="handleSizeChange"
             style="float: right"
             background
             layout="prev, pager, next"
             :total="count"
             :page-size="5"
             :current-page="1"
            >
           </el-pagination>
         </div>

       </div>

      <div style="height: 100px"></div>
      <footee></footee>

    </div>

</template>

<script>
  import HeadMenu from '../../share/head-mean'
  import footee from '../../share/footer.vue'
  import BK from '../../share/fh.vue'
  export default {
    created(){
      this.dataList(1)
      this.getSession()
      this.getlist()
    },
    mounted(){
    if(localStorage.getItem('language')){
      this.language =localStorage.getItem('language')
    }else{
      this.language = 'CN'
    }
    },
    components:{
      "head-menu":HeadMenu,
      "footee":footee,
      "BK":BK
    },
    name: "newsCenteru",
    data(){
      return {
        CNtitle:"道远观察",
        ENtitle:"Realated News",
        bg: require('@/assets/newsCenteru/12.png'),
        activeIndex:'道远资本观察',
        language:"CN",
        type:1,
        fromPage:{
          pageSize:5,
          pageNum:1,
          newsId:3
        },
        isPageShow:true,
        count:0,
        newList:[
          {
            id:'1',
            tiles:'新冠病毒确诊的主要检测方法',
            info:'新冠病毒确诊的主要检测方法',
            imgUrl:require('@/assets/newsCenteru/imgNR.png'),
            time:'2020-03-21',
            isShow:false
          },{
            id:'2',
            tiles:'Multitude Therapeutics – A rising star for anti-cancer therapy',
            info:'Multitude Therapeutics – A rising star for anti-cancer therapy',
            imgUrl:require('@/assets/newsCenteru/imgNR.png'),
            time:'2020-03-20',
            isShow:false
          },{
            id:'3',
            tiles:'创业投资基金减持新规助力生物医药产业投资进入融与退的良性循环',
            info:'创业投资基金减持新规助力生物医药产业投资进入融与退的良性循环',
            imgUrl:require('@/assets/newsCenteru/imgNR.png'),
            time:'2020-03-15',
            isShow:false
          },


        ],
        guanchaList:[
          {
            id:'1',
            tiles:'新冠病毒确诊的主要检测方法',
            info:'新冠病毒确诊的主要检测方法',
            imgUrl:require('@/assets/newsCenteru/imgNR.png'),
            time:'2020-03-21',
            isShow:false
          },{
            id:'2',
            tiles:'Multitude Therapeutics – A rising star for anti-cancer therapy',
            info:'Multitude Therapeutics – A rising star for anti-cancer therapy',
            imgUrl:require('@/assets/newsCenteru/imgNR.png'),
            time:'2020-03-20',
            isShow:false
          },{
            id:'3',
            tiles:'创业投资基金减持新规助力生物医药产业投资进入融与退的良性循环',
            info:'创业投资基金减持新规助力生物医药产业投资进入融与退的良性循环',
            imgUrl:require('@/assets/newsCenteru/imgNR.png'),
            time:'2020-03-15',
            isShow:false
          }]
          ,
        qitaList:[{}],
        kuaiXunList:[
          {
            id:'4',
            tiles:'华科泰新冠病毒检测试剂盒获欧盟CE认证和ISO 13485认证并开始出口海外',
            info:'华科泰新冠病毒检测试剂盒获欧盟CE认证和ISO 13485认证并开始出口海外',
            imgUrl:require('@/assets/newsCenteru/123.jpg'),
            time:'2020-03-17',
            isShow:false
          },{
            id:'5',
            tiles:'IVD企业“硬核”仪器为一线保驾护航',
            info:'IVD企业“硬核”仪器为一线保驾护航',
            imgUrl:require('@/assets/newsCenteru/123.jpg'),
            time:'2020-03-04',
            isShow:false
          },{
            id:'6',
            tiles:'葛兰素史克与三叶草生物达成新冠病毒疫苗合作',
            info:'葛兰素史克与三叶草生物达成新冠病毒疫苗合作',
            imgUrl:require('@/assets/newsCenteru/123.jpg'),
            time:'2020-02-25',
            isShow:false
          },


        ]

      }
    },
    methods:{
      getSession(){
        if (sessionStorage.getItem("activeIndex")){
          if(sessionStorage.getItem("activeIndex")=='道远资本观察'){
            this.activeIndex=sessionStorage.getItem("activeIndex")
            // this.newList=this.guanchaList
          }else {
            this.activeIndex=sessionStorage.getItem("activeIndex")
            // this.newList=this.kuaiXunList
          }
        }else {
          sessionStorage.setItem("activeIndex",'道远资本观察');
        }
      },getlist(){
         this.newList=[]
        if(this.activeIndex==='道远资本观察'){
         this.fromPage.newsId='3'
        }else{
          this.fromPage.newsId='2'
        }
        this.$axios.post('/newsCenter/getNews',this.fromPage).then(res=>{
          this.count=res.data.entity.total
          this.newList=res.data.entity.list
          this.newList.forEach(item=>{
            if(this.activeIndex==='道远资本观察'){
              item['imgUrl']=require('@/assets/newsCenteru/imgNR.png')
            }else{
              item['imgUrl']=require('@/assets/newsCenteru/123.jpg')
            }
            item['isShow']=false
          })
          if(this.newList.length>0){
            this.newList[0].isShow=true
            this.isPageShow=true
          }else{
            this.isPageShow=false
          }
          this.$forceUpdate();
        })
      }
      ,
      handleSelect(key){
        this.activeIndex=key
      },
      over(varx){
        for(let index=0;index<this.newList.length;index++){
             if(varx===index){
               this.newList[index].isShow=true
             }else{
               this.newList[index].isShow=false
             }

        }
        //强制刷新页面渲染
        this.$forceUpdate();
      },dataList(varx){
        if(varx===1){
          this.type=1
          this.newList=this.guanchaList;
          if(this.language=='CN'){
            this.CNtitle="道远观察";
          }else{
            this.CNtitle="Tao capital observation";
          }
          
          this.ENtitle="Realated News";
          sessionStorage.setItem("activeIndex",'道远资本观察')
        }else if(varx===2){
          this.newList=this.kuaiXunList;
          this.type=2
          if(this.language=='CN'){
            this.CNtitle="道远快讯";
          }else{
            this.CNtitle="Tao capital insight";
          }
          this.ENtitle="Information";
          sessionStorage.setItem("activeIndex",'道远资本快讯')
        }else{
          console.log("其他")
          this.type=3
          this.newList=[];
        }
        this.fromPage.pageNum=1
        this.getlist()
      },linkinfo(data){
        var varx=data.id;
        console.log("id====="+varx)
        this.$router.push({path:'/NewInfo/'+varx})
        // if(varx==1){
        //   this.$router.push({path:'/bingdujiance/'+varx})
        // }else if(varx==2)
        // {
        //   this.$router.push({path:'/arnticancertherapy'})
        // }else if(varx==3)
        // {
        //   this.$router.push({path:'/chuangyetouzi'})
        // }else if(varx==4)
        // {
        //   this.$router.push({path:'/huaketaijianceji'})
        // }else if(varx==5)
        // {
        //   this.$router.push({path:'/idvqiye'})
        // }else if(varx==6)
        // {
        //   this.$router.push({path:'/sanyecaohezuo'})
        // }
      },handleSizeChange(valx){
        this.fromPage.pageNum=valx
        this.getlist()
      }
    }
  }
</script>

<style scoped>

.itemx-our-1{
  height: 54px !important;
  line-height: 54px !important;
  margin-top: 0px !important;
}
.xi{
  margin-left: 0px !important;
}
.xz1{
  border-bottom: 2px solid #083A6F !important;
}
@media screen and (min-width: 1210px){
  .news-Centeru-banner{
    height: 400px;
  }
  .news-Centeru-banner-img{
    display: none !important;
  }
  .show-news-head-tlie{
    display: none;
  }


}

@media screen and (max-width: 1210px){
  .show-news-head-tlie2{
    display: none;
  }
}

@media screen and (min-width: 750px){
  .news-Centeru-tow-list{
    display:none;
  }
  .news-Centeru-imgx{
    height: 200px;
  }
}
@media screen and (max-width: 750px){
  .news-Centeru-tow-list1{
    display:none;
  }
  .news-Centeru-imgx{
    height: 100px;
  }
  .news-Centeru-nr{
    height:300px !important
  }
}
.news-Centeru-nr{
  cursor: pointer;
  max-width: 1210px;
  height: 270px;
  background:#FFFFFF;
  margin: 0 auto;
  margin-top:100px;
  border-bottom: 2px solid rgba(102,100,100,1);
}
/*.news-Centeru-nr:hover{*/
/*  box-shadow:5px 8px 10px 0px rgba(188,188,188,0.53), -4px -8px 10px 0px rgba(188,188,188,0.15);*/
/*  border-bottom: 2px solid rgba(8,58,111,1);*/
/*  background-color: #fff;*/
/*}*/
.news-Centeru-text-one{
  font-size:16px;
  line-height:20px;
  font-weight:400;
  float: left;
}
.news-Centeru-text-tow{
   font-size:14px;
   font-weight:400;
   color:rgba(152,152,152,1);
   float: left;
   line-height: 25px;
 }
.news-Centeru-text-three{
  margin-top: 45px;
  color:rgba(152,152,152,1);
  line-height:28px;
  font-size: 14px;
}
.news-Centeru-tile{
  margin-top: 35px;
  text-align: center;
  font-size:30px;
  font-weight:400;
}
  /deep/ .el-menu-item{
    padding: 0px;
  }
/deep/ .el-menu--horizontal>.el-menu-item.is-active{
  font-weight:bold;
  color:rgba(8,58,111,1);
  border-bottom: 0px;
}
.gd{
  height: 150px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/newsCenteru/index.vue